import { MenuHandler, MenuItem } from '@heda/core-hospital-ui';
import { Observable, of } from 'rxjs';
import { environment } from 'environments/environment';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { IntegrationService } from 'app/integration/integration.service';

@Injectable()
export class UserInfoMenuHandler extends MenuHandler {
  public handleMenu(menu: MenuItem[]): Observable<any> {
    if (!environment.production && environment.yupiEnabled) {
      menu.push({
        code: 'yupi',
        names: { en: 'Yupi', et: 'Yupi' },
        icon: 'bug',
        uri: '/proto/userinfo',
      });
    }
    return of(true);
  }
}

@Injectable()
export class EsterMenuHandler extends MenuHandler {
  constructor(private integrationService: IntegrationService) {
    super();
  }

  public handleMenu(menu: MenuItem[]): Observable<any> {
    return this.integrationService.isHedesterEnabled().pipe(
      tap((enabled) => {
        if (enabled) {
          menu.push({
            code: 'iester',
            names: { en: 'iEster', et: 'iEster' },
            icon: 'link',
            uri: '/integration/iester',
          });
        }
      })
    );
  }
}
